// React-Binding für den positionBus. Gibt die aktuelle Position (wenn
// LocateControl aktiv ist und ein Fix reingekommen ist) oder null.
//
// Absichtlich KEIN eigener watchPosition: das würde a) eine zweite Permission-
// Prompt triggern können und b) GPS doppelt bemühen. Stattdessen lesen wir
// was LocateControl ohnehin sammelt.

import { useSyncExternalStore } from 'react';
import { positionBus } from './positionBus';

export function useCurrentPosition(): GeolocationCoordinates | null {
  return useSyncExternalStore(
    (cb) => positionBus.subscribe(cb),
    () => positionBus.get(),
    () => null,
  );
}
